if (!customElements.get('shop-list-page')) {
    customElements.define('shop-list-page', class ShopListPage extends HTMLElement {
        constructor() {
            super();

            this.key_boards = this.querySelectorAll(".js-keyboard");
            this.switch_layout = this.querySelectorAll(".js-switch-layout");
            this.key_board_layouts = this.querySelectorAll(".js-keyboard-layout");
            this.search_field = this.querySelector(".js-search-field");
            this.key_buttons = this.querySelectorAll(".js-key");
            this.back_layout_alphabet = this.querySelectorAll(".js-back-alphabet");
            this.filtered_list = this.querySelector('#filteredList');

            this.searchForm = this.querySelector('.shop-list-page__search-form form');

            this.data = JSON.parse(document.getElementById('data_creator').textContent);
            let index_arr = [];
            this.data.map(item => {
                if (item.indexjp != '') {
                    index_arr.push(item.indexjp);
                }
                if (item.indexen != '') {
                    index_arr.push(item.indexen.toLowerCase());
                }
            });
            this.value_uique = this.removeDuplicates(index_arr);
            this.init(); 
            let currentUrl = window.location.href;
            if ( !currentUrl.includes('?q=')) {
             this.filtered_list.style.display = 'block';
            }

        }

        init() {
            this.key_buttons.forEach((key) => {
                let value = key.getAttribute("data-value").toLocaleLowerCase();
                this.filteredData(value);
            });


            this.key_buttons.forEach((key) => {
                key.addEventListener("click", (e) => {
                    document.getElementById('searchedList').style.display = 'none';
                    this.filtered_list.style.display = 'block';
                    const searchText = document.getElementById('searchCreatorTxt').value.toLowerCase();
                    if (searchText) {
                    }
                    let value = e.currentTarget.getAttribute("data-value").toLowerCase();
                    // let target = this.search_field;
                    // target.value = target.value + value;
                    this.scrollToResult(value);
                }, this);
            }, this);

            this.search_field.addEventListener("focus", () => {
                window.addEventListener("keydown", ({ code }) => {
                    code = code.toLowerCase().replace("key", "").replace("digit", "");
                    this.key_buttons.forEach((key) => {
                        if (key.getAttribute("data-value") === code) {
                            key.classList.add("active");
                        }
                    });
                }, this);
                  
                window.addEventListener("keyup", ({ code }) => {
                    code = code.toLowerCase().replace("key", "").replace("digit", "");
                    this.key_buttons.forEach((key) => {
                        if (key.getAttribute("data-value") === code) {
                            key.classList.remove("active");
                        }
                    });
                }, this);
            }, this);

            this.switch_layout.forEach((selector) => {
                selector.addEventListener("click", (e) => {
                    let data_layout = e.currentTarget.getAttribute("data-layout");
                    if (data_layout != "layout-number") {
                        e.currentTarget.classList.add("active");
                        this.switch_layout.forEach((el) => {
                            if (el !== e.currentTarget) {
                                el.classList.remove("active");
                            }
                        });
                    }
                    
                    this.key_board_layouts.forEach((el) => {
                        if (el.getAttribute("data-layout") === data_layout) {
                            el.classList.add("active");
                        } else {
                            el.classList.remove("active");
                        }
                    });
                });
            });

            // let currentUrl = window.location.href;
            // if(currentUrl.includes('?q=')) {
            //     let searchValue = decodeURIComponent(currentUrl.split('?q=')[1]);
            //     this.search_field.value = searchValue;
            //     // searchValue = searchValue.charAt(0).toLowerCase();
            //     this.checkInputValue(searchValue);
            // }

            // this.search_field.addEventListener("input", (e) => {
            //     let value = e.target.value[0];
            //     // value = value.replace(/[\u30A1-\u30FA]/g, (char) => {
            //     //     return String.fromCharCode(char.charCodeAt(0) - 0x60);
            //     // });
            //     this.checkInputValue(value);
            //   console.log(value);
            // });

            this.searchForm.addEventListener('submit', (e) => {
                e.preventDefault();
            });
        }

        scrollToResult(character) {
            let currentSection = 1
            const section = document.getElementById(`character-${character}`);
            if (section) {
                const sectionTop = section.offsetTop;
                window.scrollTo({
                    top: sectionTop,
                    behavior: "smooth"
                });
            }
    
            currentSection++;
    
            if (currentSection > 3) {
                currentSection = 1; 
            }

        }

        filteredData(character) {
            const filteredData = this.data.filter(item => {
                if (item.display != '1'){
                const indexEN = item.indexen.toLowerCase();
                const indexJP = item.indexjp;
                return indexEN.includes(character) || indexJP.includes(character);
                }
            });
            
            if (filteredData.length > 0) {
                let alphabet = `<div class="row" id="character-${character}">
                    <span class="title">${character.toUpperCase()}</span>
                    <ul>
                        ${
                            filteredData.map(item => {
                                let title = item.title;
                                let thumbnail = item.image;
                                let link = item.link;
                                return `<li data-creator="${title.toLowerCase()}">
                                    <a href="/pages/${link}" target="_blank">
                                        <img src="${thumbnail}" alt="${title}" />
                                        <span>${title}</span>
                                    </a>
                                </li>`
                            }).join('')
                        }
                    </ul>
                </div>`; // Clear previous results

                this.filtered_list.innerHTML += alphabet;

            }
            // Disable the button if no results are found
            this.toggleButtonState(character, filteredData.length === 0);

        }

        removeDuplicates(arr) {
            return [...new Set(arr)];
        }

        toggleButtonState(character, disable) {
            const buttons = document.querySelectorAll(`.shop-list-page__keyboard--key[data-value="${character}"]`);
            buttons.forEach(button => {
                if (button) {
                    button.disabled = disable;
                }
            });
        }

        checkInputValue(value) {
            // let firtChar = value.charAt(0).toLowerCase();
            if(this.filtered_list.hasChildNodes()) {
                if (value != '') {
                    this.filtered_list.querySelectorAll('div.row').forEach((el) => {
                        el.style.display = 'none';
                    });

                    if (this.filtered_list.querySelector(`#character-${value.charAt(0).toLowerCase()}`) != null) {
                      console.log("search-" + value);
                        this.filtered_list.querySelectorAll('li[data-creator]').forEach((el) => {
                            el.style.display = 'none';
                        });
                        this.filtered_list.querySelector(`#character-${value.charAt(0).toLowerCase()}`).style.display = 'block';
                        let currentChar = this.filtered_list.querySelector(`#character-${value.charAt(0).toLowerCase()}`);
                        
                        if (currentChar.querySelectorAll(`li[data-creator*="${value.toLowerCase()}"]`).length > 0) {
                            const matchingItems = currentChar.querySelectorAll(`li[data-creator*="${value.toLowerCase()}"]`);
                            matchingItems.forEach(item => {
                                item.style.display = 'block';
                            });
                            this.querySelector('.js-not-found').style.display = 'none';
                        } else {
                            console.log('not found');
                            this.filtered_list.querySelectorAll('div.row').forEach((el) => {
                                el.style.display = 'none';
                            });
                            this.querySelector('.js-not-found').style.display = 'block';
                            this.querySelector('.js-not-found').innerHTML = 
                                ` 
                                    <p class="result">"${value}"の検索結果</p>
                                    <p class="text">一致するクリエイターショップが見つかりませんでした。</p>
                                `;
                        } 
                    } else {
                        this.querySelector('.js-not-found').style.display = 'block';
                        this.querySelector('.js-not-found').innerHTML = 
                            `
                                <p class="result">"${value}"の検索結果２</p>
                                <p class="text">一致するクリエイターショップが見つかりませんでした。</p>
                            `;
                    }
                } else {
                  
                    this.filtered_list.querySelectorAll('div.row').forEach((el) => {
                        el.style.display = 'block';
                        el.querySelectorAll('li[data-creator]').forEach((el) => {
                            el.style.display = 'block';
                        });
                    });
                    this.querySelector('.js-not-found').style.display = 'none';
                }
            } 
        }
    });
  }
